import { Youtube, ThumbsUp, ThumbsDown, Share2, Download } from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot } from "./PreviewShell";

export function YoutubePreview(props: PreviewProps) {
  if (props.device === "mobile") {
    return (
      <PreviewShell device="mobile" mobileFrame={false}>
        <div className="bg-black aspect-[9/16] relative">
          <div className="absolute inset-0">
            <MediaSlot
              mediaUrl={props.mediaUrl}
              mediaType={props.mediaType}
              aspect="h-full"
              bgClass="bg-black"
              fallback={<span className="text-white/60 text-xs">Video not available</span>}
            />
          </div>
          <div className="absolute right-2 bottom-20 flex flex-col items-center gap-3.5 text-white">
            <div className="flex flex-col items-center text-[10px]">
              <ThumbsUp size={22} />
              <span>0</span>
            </div>
            <div className="flex flex-col items-center text-[10px]">
              <ThumbsDown size={22} />
            </div>
            <div className="flex flex-col items-center text-[10px]">
              <Share2 size={22} />
            </div>
          </div>
          <div className="absolute left-3 right-16 bottom-12 text-white text-[11px]">
            <div className="font-semibold line-clamp-2">{props.title || props.pageName}</div>
            <div className="opacity-75 mt-1">@{props.pageName}</div>
          </div>
        </div>
      </PreviewShell>
    );
  }
  return (
    <PreviewShell device="desktop">
      <MediaSlot
        mediaUrl={props.mediaUrl}
        mediaType={props.mediaType}
        aspect="aspect-video"
        bgClass="bg-black"
        fallback={<span className="text-white/60 text-xs">Video not available</span>}
      />
      <div className="p-3">
        <h3 className="text-[14px] font-semibold text-gray-900 line-clamp-2">
          {props.title || props.pageName}
        </h3>
        <p className="text-[11px] text-gray-500 mt-1">0 views · just now</p>
        <div className="flex items-center gap-3 mt-3">
          {props.pageAvatarUrl ? (
            <img
              src={props.pageAvatarUrl}
              alt={props.pageName}
              className="w-9 h-9 rounded-full object-cover bg-gray-100"
            />
          ) : (
            <div className="w-9 h-9 rounded-full flex items-center justify-center bg-red-50">
              <Youtube size={18} className="text-red-600" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="text-[12px] font-semibold text-gray-900 truncate uppercase">
              {props.pageName}
            </p>
          </div>
          <button className="text-[11px] font-semibold text-white bg-black rounded-full px-3 py-1.5">
            Subscribe
          </button>
        </div>
        <div className="flex items-center gap-2 mt-3 text-gray-700 text-[11px]">
          <span className="inline-flex items-center gap-1 bg-gray-100 rounded-full px-3 py-1.5">
            <ThumbsUp size={13} /> 0
          </span>
          <span className="inline-flex items-center gap-1 bg-gray-100 rounded-full px-3 py-1.5">
            <ThumbsDown size={13} />
          </span>
          <span className="inline-flex items-center gap-1 bg-gray-100 rounded-full px-3 py-1.5">
            <Share2 size={13} /> Share
          </span>
          <span className="inline-flex items-center gap-1 bg-gray-100 rounded-full px-3 py-1.5">
            <Download size={13} /> Download
          </span>
        </div>
        {props.caption && (
          <div className="mt-3 bg-gray-100 rounded-lg p-3 text-[11px] text-gray-700 whitespace-pre-wrap line-clamp-3">
            {props.caption}
          </div>
        )}
      </div>
    </PreviewShell>
  );
}
